/**
 * Affiliate Tracking (incognito®)
 *
 * Captures ?ref=<name> from URLs, persists it last-touch for 30 days,
 * and writes it to cart.attributes.ref so Shopify Flow can tag orders.
 *
 * Tracking only — no discount logic. Attribution is reconciled manually
 * from tagged orders by the marketing exec.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'incognito_ref';
  var COOKIE_NAME = 'incognito_ref';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  var VALID_NAME = /^[a-z0-9_-]{1,40}$/;

  function sanitize(raw) {
    if (!raw) return null;
    var v = String(raw).trim().toLowerCase();
    return VALID_NAME.test(v) ? v : null;
  }

  function readStorage() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.value || !parsed.expiresAt) return null;
      if (Date.now() > parsed.expiresAt) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return sanitize(parsed.value);
    } catch (e) {
      return null;
    }
  }

  function writeStorage(value) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ value: value, expiresAt: Date.now() + TTL_MS })
      );
    } catch (e) {}
    // Fallback cookie for Safari ITP / cross-subdomain cases
    document.cookie =
      COOKIE_NAME + '=' + value + '; max-age=' + (TTL_MS / 1000) + '; path=/; SameSite=Lax';
  }

  function readCookie() {
    var match = document.cookie.match(/(?:^|; )incognito_ref=([^;]+)/);
    return match ? sanitize(decodeURIComponent(match[1])) : null;
  }

  function captureFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      return sanitize(params.get('ref'));
    } catch (e) {
      return null;
    }
  }

  function syncCartAttribute(value) {
    // Check current cart attribute; skip POST if it already matches
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var current = cart.attributes && cart.attributes.ref;
        if (current === value) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { ref: value } })
        });
      })
      .catch(function () { /* silent — tracking must never break the page */ });
  }

  function init() {
    // Last-touch: URL wins over stored value
    var fromUrl = captureFromUrl();
    if (fromUrl) {
      writeStorage(fromUrl);
    }
    var ref = readStorage() || readCookie();
    if (ref) {
      syncCartAttribute(ref);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
